module.exports = __webpack_public_path__ + "88498bd7455b28243f7787306c31cd1b.png";